var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "app-launcher" } },
    [
      _vm.showAppHeader
        ? _c("app-launcher-header", {
            attrs: {
              avatar: _vm.avatar,
              agent: _vm.agent,
              "actions-type": _vm.actionsType,
              "app-version": _vm.appVersion,
              "is-updating": _vm.isUpdating,
            },
            on: {
              "go-back": function ($event) {
                return _vm.$emit("go-back")
              },
              "option-click": function ($event) {
                return _vm.$emit("option-click", $event)
              },
              save: function ($event) {
                return _vm.$emit("save")
              },
              update: function ($event) {
                return _vm.$emit("update")
              },
              cancel: function ($event) {
                return _vm.$emit("cancel")
              },
              "sign-out": function ($event) {
                return _vm.$emit("sign-out")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAppContentLoader
        ? _c("base-content-loader", {
            attrs: {
              title: _vm.$t("HITL.app-launcher.initialize-title"),
              description: _vm.description,
            },
          })
        : _c(
            "div",
            {
              staticClass: "content",
              class: { "is-center-content": !_vm.isUsingBundle },
            },
            [_vm._t("default")],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }